export default {
  NEOMECCA: 'NEOMECCA',
  KT: 'KT',
  KLCNS: 'KLCNS',
  NEO_WEB_RTC: 'NEO_WEB_RTC'
};



// WEBPACK FOOTER //
// ./src/constants/callChannelType.js